import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';
// import { AuthService } from 'src/services';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/services';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent {
  loginForm!: FormGroup;
  isPasswordVisible = false;
  emailControl = new FormControl('', [Validators.required, Validators.pattern("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$")]);
  password = '';
  token;
  user;
  // private service: AuthService
  constructor(private formBuilder: FormBuilder, private router: Router, private service: AuthService) 
  {
    this.checkLogin();
  }

  ngOnInit() 
  {
    this.loginForm = this.formBuilder.group(
    {
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  }
  
  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  getEmailErrorMessage() 
  {
    if (this.emailControl.hasError('required')) 
    {
      return 'You must enter a value';
    }

    return this.emailControl.hasError('pattern') ? 'Not a valid email' : '';
  }

  login() 
  {
    const { password, email } = this.loginForm.value;
    this.service.login({ password, email, role: '' }).subscribe((res: any) => 
    {
      const { success, token, data, message, sso, user } = res
      if (success) 
      {
        localStorage.setItem(environment.auth_token, token);
        localStorage.setItem('user', JSON.stringify(user));
       
        if (sso) 
        {
          localStorage.setItem(environment.sso_token, sso.token);
          localStorage.setItem('sso_details', JSON.stringify(sso));
        }

        this.user = user;
        if (localStorage.getItem('user')) 
        {
          this.route()
        }
      }
      else 
      {
        this.service.showToast('error', message)
      }
    }, this.service.error)
  }

  private route() 
  {
    this.user = JSON.parse(localStorage.getItem('user'));
    
    if (this.user?.homePage) 
    {
      this.router.navigate([`/${this.user.homePage}`]).then(() => { });
    }
    else 
    {
      this.router.navigate(['ports']).then(() => { });
    }
  }

  forgetPassword() {
    // this.service.forgetPassword({ email: this.emailControl }).subscribe((res: any) => {
    //   const { success, data, message } = res
    //   if (success) {
    //     this.service.showToast("success", message)
    //     this.router.navigate(['/login']);
    //   }
    //   else {
    //     this.service.showToast("info", message)
    //   }
    // }, this.service.error)
  }

  checkLogin() 
  {
    if (localStorage.getItem(environment.auth_token) && localStorage.getItem('user')) 
    {
      this.route();
    }
  }

}
